export default __webpack_public_path__ + "static/media/Mask Group-2.38cc633c.png";